import { NAME_SPACE as ns, ROOT_STATE_KEY as sk } from './constants';

export const SET_USER_HIDDEN_COLUMNS = `${ns}_${sk}_SET_USER_HIDDEN_COLUMNS`;

export const SET_USER_APP_SETTINGS = `${ns}_SET_USER_APP_SETTINGS`;
